import {
  DataTable,
  Loading,
  useTranslation,
} from "@/imports-files/components/datatable/datatable";

export function CustomDataTable({
  columns,
  data,
  totalCount,
  router,
  datatableLoading,
  onRowClick,
  onSort,
  onChangeRowsPerPage,
  onChangePage,
  ...rest
}) {
  const { t } = useTranslation();

  return (
    <DataTable
      columns={columns}
      data={data || []}
      paginationTotalRows={totalCount || 0}
      onSort={onSort}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onChangePage={onChangePage}
      progressPending={datatableLoading}
      progressComponent={<Loading />}
      onRowClicked={(row) => {
        if (onRowClick) return onRowClick(row);
      }}
      noDataComponent={t("datatable:no_records")}
      paginationComponentOptions={{
        rowsPerPageText: t("datatable:rows_per_page"),
        rangeSeparatorText: t("datatable:of"),
      }}
      paginationServer
      sortServer
      pagination
      {...rest}
    />
  );
}
